import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataViewPageProvider {
  public readonly exportTrigger = new Subject<boolean>();
  public readonly exportFinished = new Subject<void>();
}
